import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { default as ReactSelect } from "react-select";
import { Props as ReactSelectProps } from "react-select/lib/Select";

import { getReactSelectStyles } from "../constants";
import { messages } from "../messages";

interface DefaultOption {
    label: string;
    value: string;
}

interface SelectProps<T = DefaultOption> extends ReactSelectProps<T> {
    placeholderMessage?: MessageDescriptor;
}

type Props<T> = SelectProps<T>;

const Select = <T extends unknown>({ placeholderMessage, ...props }: Props<T>) => {
    const { formatMessage } = useIntl();
    const translations = {
        noOptionsMessage: () => formatMessage(messages.selectNoResults),
        loadingMessage: () => formatMessage(messages.selectLoading),
        placeholder: formatMessage(
            placeholderMessage != null ? placeholderMessage : messages.selectPlaceholderLabel,
        ),
    } as ReactSelectProps<T>;

    return (
        <ReactSelect
            classNamePrefix="react-select"
            styles={getReactSelectStyles()}
            {...translations}
            {...props}
        />
    );
};

type DefaultSelect = typeof Select<DefaultOption>;
const DefaultSelect = Select as typeof Select<DefaultOption>;

export {
    DefaultOption,
    Select,
    DefaultSelect,
    SelectProps,
};
